import * as stylex from "@stylexjs/stylex";
import { useContentRect } from "../hooks";
import { layout } from "../materials/layout.stylex";
import { Line as FixedWidthLineChart } from "./lib/Lines";
export function LineChart(props) {
    const [ref, contentRect] = useContentRect();
    return <div ref={ref} {...stylex.props(layout.fullWidth)}>
      {contentRect.width > 0 && <FixedWidthLineChart {...props} width={contentRect.width}/>}
    </div>;
}
